import { render, staticRenderFns } from "./TenderLetter.vue?vue&type=template&id=3b9a9946"
import script from "./TenderLetter.vue?vue&type=script&setup=true&lang=js"
export * from "./TenderLetter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports